import { Color } from "@mui/material";

type SolidColor = Omit<Color, "A100" | "A200" | "A400" | "A700">;

const Blue: SolidColor = {
    50: "#E6E6FF",
    100: "#CDCCFF",
    200: "#9B99FF",
    300: "#6966FF",
    400: "#3733FF",
    500: "#0500FF",
    600: "#0400CC",
    700: "#030099",
    800: "#020066",
    900: "#010033",
};

const Gray: SolidColor = {
    50: "#F9FAFB",
    100: "#F2F4F7",
    200: "#EAECF0",
    300: "#D0D5DD",
    400: "#98A2B3",
    500: "#667085",
    600: "#475467",
    700: "#344054",
    800: "#1D2939",
    900: "#101828",
};

const Green: SolidColor = {
    50: "#E9F3ED",
    100: "#D2E7DB",
    200: "#A6CFB8",
    300: "#79B694",
    400: "#4D9E71",
    500: "#20864D",
    600: "#1A6B3E",
    700: "#13502E",
    800: "#0D361F",
    900: "#061B0F",
};

const Orange: SolidColor = {
    50: "#FEF2EF",
    100: "#FDE6DF",
    200: "#FACCBF",
    300: "#F8B39E",
    400: "#F5997E",
    500: "#F3805E",
    600: "#C2664B",
    700: "#924D38",
    800: "#613326",
    900: "#311A13",
};

const Purple: SolidColor = {
    50: "#F0EBFD",
    100: "#E1D7FC",
    200: "#C3AFF9",
    300: "#A588F5",
    400: "#8760F2",
    500: "#6938EF",
    600: "#542DBF",
    700: "#3F228F",
    800: "#2A1660",
    900: "#150B30",
};

const Red: SolidColor = {
    50: "#F8E8EC",
    100: "#F1D1D9",
    200: "#E3A3B4",
    300: "#D5748E",
    400: "#C74669",
    500: "#B91843",
    600: "#941336",
    700: "#6F0E28",
    800: "#4A0A1B",
    900: "#25050D",
};

const Yellow: SolidColor = {
    50: "#FFF9EB",
    100: "#FFF3D7",
    200: "#FFE6AE",
    300: "#FEDA86",
    400: "#FECD5D",
    500: "#FEC135",
    600: "#CB9A2A",
    700: "#987420",
    800: "#664D15",
    900: "#33270B",
};

export const Colors = { Blue, Gray, Green, Orange, Purple, Red, Yellow };
